import React, { useContext } from 'react';
import { ListItem } from 'src/components/dropdown-new/item';
import { AppState } from 'src/reducers';
import { RadioButton } from '@prisjakt/ui/radiobutton';
import { AppContext } from '@prisjakt/ui-app-context';
import { useDispatch, useSelector } from 'react-redux';
import { offerSorting } from 'src/areas/product/actions/product';
import { getSortOptions, translateSort } from './utils';
import { SortOptionEnum } from 'src/components/price-list/types';
import { saveSortingAsUserSettings } from '../offer-list-filters/utils';
import { defaultProductState } from 'src/areas/product/reducer';
import { SortOptionsList } from './styles';

export const SortOptions: React.FC<ISortOptions> = props => {
  const { renderAllOptions } = props;
  const { t } = useContext(AppContext);
  const dispatch = useDispatch();
  const currentSort =
    useSelector((state: AppState) => getSortState(state)) ||
    defaultProductState.sorting;
  const sortOptions = getSortOptions(currentSort, renderAllOptions);
  const sort = (selectedSort: SortOptionEnum) => {
    saveSortingAsUserSettings(selectedSort);
    dispatch(offerSorting(selectedSort));
  };

  return (
    <SortOptionsList>
      {sortOptions.map(sortOption => {
        const label = translateSort(t, sortOption);

        return renderAllOptions ? (
          <RadioButton
            key={sortOption}
            id={sortOption}
            name="radioSortOptions"
            selectedValue={currentSort}
            value={sortOption}
            onClickHandler={() => sort(sortOption)}
            text={label}
          />
        ) : (
          <ListItem key={sortOption} onClick={() => sort(sortOption)}>
            {label}
          </ListItem>
        );
      })}
    </SortOptionsList>
  );
};

const getSortState = (state: AppState) => state.areas.product.sorting;

interface ISortOptions {
  renderAllOptions: boolean;
}
